import { Box, VStack } from "@chakra-ui/react";
import { Input, InputLabel, Select } from "components";
import { useRedebounce } from "hooks";
import { IQuote } from "interfaces";
import { useState } from "react";

interface Props {
  set: (update: Partial<IQuote>) => void;
  state: Partial<IQuote>;
  buyCheck: boolean;
  checkBuyRate: (
    price: number,
    opts?: {
      country?: string;
      bankName?: string;
      mobileNumber?: string;
    }
  ) => Promise<any>;
}
const FrancoBankDetails = ({ set, checkBuyRate, state, buyCheck }: Props) => {
  const redebounce = useRedebounce();
  const mappedBank = {
    cameroon: ["cameroon orange", "orange", "cameroon mtn", "mtn"],
    senegal: ["orange", "senegal orange", "orange senegal", "free money", "free money senegal", "senegal free mobile"],
    "cote d'ivoire": ["moov", "mtn", "ivory coast mtn", "ivory coast moov"],
    "": [],
  };
  type IB = keyof typeof mappedBank;
  const [country, setCountry] = useState<IB>("");

  return (
    <VStack alignItems="revert-layer" spacing="16px" px="4px" pb="24px">
      <Box>
        <InputLabel htmlFor="country">Country</InputLabel>
        <Select
          id="country"
          name="country"
          onChange={(e) => {
            const _value = e.target.value;
            set({
              country: _value,
            });
            setCountry(_value as IB);
            if (buyCheck)
              redebounce(() => checkBuyRate(+(state.fiatAmount ?? 0), { ...state, country: _value }), "checkBuyRate", 1000)();
          }}
          defaultValue={state?.country}
          // isDisabled={isDisabled}
        >
          <option value="cameroon">Select Country</option>
          <option value="cameroon">Cameroon</option>
          <option value="senegal">Senegal</option>
          <option value="cote d'ivoire">Cote D'Ivoire</option>
        </Select>
      </Box>

      <Box>
        <InputLabel mb="2px" display="block" fontSize="14px" htmlFor="bankName">
          Bank Name
        </InputLabel>

        <Select
          onChange={(e) => {
            const _value = e.target.value;
            set({
              bankName: _value,
            });
            if (buyCheck)
              redebounce(() => checkBuyRate(+(state.fiatAmount ?? 0), { ...state, bankName: _value }), "checkBuyRate", 1000)();
          }}
          isDisabled={country.length === 0}
          defaultValue={state?.bankName}
        >
          <option value="">Select Bank</option>
          {mappedBank[country]?.map((bank) => (
            <option key={bank}>{bank.toUpperCase()}</option>
          ))}
        </Select>
      </Box>

      <Box>
        <InputLabel mb="2px" display="block" fontSize="14px" htmlFor="mobileNumber">
          Mobile Number
        </InputLabel>

        <Input
          id="mobileNumber"
          width="100%"
          name="mobileNumber"
          // isDisabled={isDisabled}
          onChange={(e) => {
            const _value = e.target.value;
            set({ mobileNumber: _value });
            if (buyCheck)
              redebounce(
                () =>
                  checkBuyRate(+(state.fiatAmount ?? 0), {
                    ...state,
                    mobileNumber: _value,
                  }),
                "checkBuyRate",
                1000
              )();
          }}
          defaultValue={state?.mobileNumber}
          isRequired
        />
      </Box>
    </VStack>
  );
};

export default FrancoBankDetails;
